import { useState, useEffect, useMemo } from "react";
import { Tooltip, useMediaQuery } from "@mui/material";
import {
  Box,
  Typography,
  TextField,
  Autocomplete,
  CircularProgress,
  Card,
  CardContent,
  Grid,
  LinearProgress,
} from "@mui/material";
import axios from "axios";
import Fuse from "fuse.js";
import stringSimilarity from "string-similarity";
import { Chart as ChartJS, ArcElement, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import Slider from '@mui/material/Slider';

const cellStyle = {
  padding: "20px",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "1.2rem",
  wordBreak: "break-word",
  whiteSpace: "normal",
  overflowWrap: "break-word",
};


export const DynamicGraph = (rawValue) => {

  const numericValue = rawValue ? rawValue?.rawValue : 0   // convert "200X" → 200


  const getDynamicRange = (value) => {
    if (value > 1000 && value <= 5000) {
      return { min: 1000, max: 5000 };
    }

    // Default rule for all other values
    if (value <= 1000) {
      return { min: 0, max: 1000 };
    }

    const digits = value.toString().length;
    const step = Math.pow(10, Math.max(1, digits - 2));
    const max = Math.ceil(value / step) * step;

    return { min: 0, max };
  };

  // 3) Now call it — dynamicMin & dynamicMax are defined here
  const { min: dynamicMin, max: dynamicMax } = getDynamicRange(numericValue);

  const generateMarks = (min, max, steps = 5) => {
    const gap = (max - min) / (steps - 1);
    return Array.from({ length: steps }, (_, i) => {
      const value = Math.round(min + i * gap);
      return { value, label: `${value}x` };
    });
  };

  const marks = generateMarks(dynamicMin, dynamicMax, 5);

  function valuetext(value) {
    return `${value}°C`;
  }

  return (
    <div className="range_slider">
      <Slider
        aria-label="Custom marks"
        value={numericValue}
        onChange={() => { }}
        getAriaValueText={valuetext}
        step={100}
        min={dynamicMin}
        max={dynamicMax}
        valueLabelDisplay="auto"
        marks={marks}
      />
    </div>

  )

}

export const data = {
  // labels: ['Red'],
  datasets: [
    {
      // label: '# of Votes',
      data: [98, 2],
      backgroundColor: [
        '#099656',
        '#14FF95',
      ],
      // borderColor: [
      //   '#099656',
      // ],
      borderWidth: 0,
    },
  ],
};
export const options = {
  plugins: {
    tooltip: {
      enabled: false, // 👈 stop showing value on hover
    },
  },
};

export const TabTwo = ({ onSearchResultsFound }) => {
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [allCeoWorkerData, setAllCeoWorkerData] = useState([]);
  const [initialDataLoading, setInitialDataLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  // const [deviceType, setDeviceType] = useState("desktop");
  const isDesktop = useMediaQuery("(min-width:768px)");
  const deviceType = isDesktop ? "desktop" : "mobile";
  const [open, setopen] = useState(null);

  // const marks = [
  //   {
  //     value: 0,
  //     label: '1x',
  //   },
  //   {
  //     value: 107,
  //     label: '107x',
  //   },
  //   {
  //     value: 400,
  //     label: '400x',
  //   },
  //   {
  //     value: 800,
  //     label: '800x',
  //   },
  //   {
  //     value: 985,
  //     label: '1000x',
  //   },
  // ];



  useEffect(() => {
    // Example: fetch or set data here
    // After fetching:
    if (!loading && filteredData.length > 0) {
      onSearchResultsFound(true); // tell parent to hide header
    } else {
      onSearchResultsFound(false); // show header again
    }
  }, [loading, filteredData]);

  const formatPayRatio = (value) => {
    if (!value) return "N/A";

    return value
      .toString()
      .toLowerCase()
      .split("x")
      .map((part) => {
        const num = parseFloat(part.trim());
        return isNaN(num) ? part.trim() : num.toLocaleString("en-US");
      })
      .join("");
  };

  // useEffect(() => {
  //   const ua = navigator.userAgent;
  //   if (/Mobi|Android|iPhone|iPod|iPad/i.test(ua)) {
  //     setDeviceType("mobile");
  //   } else {
  //     setDeviceType("desktop");
  //   }
  // }, []);



  useEffect(() => {
  if (!deviceType) return;

  const fetchAllCeoWorkerData = async () => {
    setInitialDataLoading(true);
    setError("");

    try {
      // First request — also gets total count
      const firstResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/get-ceo-worker-data?device=${deviceType}&limit=3000&offset=0`
      );

      if (!firstResponse.ok) {
        throw new Error(`HTTP error! status: ${firstResponse.status}`);
      }

      const firstResult = await firstResponse.json();

      const totalCount = firstResult.count || 0;

      // IMPORTANT: use the actual property returned by your API
      const allRecords = [...(firstResult.results || firstResult.data || [])];

      // Fetch remaining pages
      for (let offset = 3000; offset < totalCount; offset += 3000) {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/get-ceo-worker-data?device=${deviceType}&limit=3000&offset=${offset}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        const records = result.results || result.data || [];

        allRecords.push(...records);
      }

      // Format EVERYTHING only once
      const formattedData = allRecords.map((item, index) => ({
        id: index,
        label: `${item["Company Name"] || ""} - ${item["CEO Name"] || ""} (${item.Year || ""})`,
        value: item["Company Name"] || "",
        companyName: item["Company Name"] || "",
        ceoName: item["CEO Name"] || "",
        year: item.Year || "",
        ceoCompensation: item["CEO Total Compensation"] || "N/A",
        workerSalary: item["Frontline Worker Salary"] || "N/A",
      }));

      setAllCeoWorkerData(formattedData);

    } catch (err) {
      console.error(err);
      setError("Failed to load data");
    } finally {
      setInitialDataLoading(false);
    }
  };

  fetchAllCeoWorkerData();

}, [deviceType]);

  const suggestions = useMemo(() => {
    if (!searchQuery?.trim() || allCeoWorkerData.length === 0) return [];

    const query = searchQuery.toLowerCase().trim();
    const queryParts = Array.from(new Set(query.match(/\w+/g) || [])); // remove duplicates

    // Extract full 4-digit year if present
    const queryYearMatch = query.match(/\b\d{4}\b/);
    const queryYear = queryYearMatch ? parseInt(queryYearMatch[0], 10) : null;

    // Levenshtein distance for fuzzy matching
    const levenshtein = (a, b) => {
      const dp = Array.from({ length: a.length + 1 }, (_, i) =>
        Array(b.length + 1).fill(0)
      );
      for (let i = 0; i <= a.length; i++) dp[i][0] = i;
      for (let j = 0; j <= b.length; j++) dp[0][j] = j;
      for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
          if (a[i - 1] === b[j - 1]) dp[i][j] = dp[i - 1][j - 1];
          else
            dp[i][j] =
              1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
        }
      }
      return dp[a.length][b.length];
    };

    const results = allCeoWorkerData
      .map((item) => {
        const company = item.companyName.toLowerCase();
        const ceo = item.ceoName.toLowerCase();
        const year = item.year;

        // If strict year exists and does not match, skip immediately
        if (queryYear && year !== queryYear) return null;

        let matches = 0;
        let multiFieldMatches = 0;
        let partialMatches = 0;

        queryParts.forEach((p) => {
          const inCompany = company.includes(p);
          const inCEO = ceo.includes(p);
          const inYear = year.toString().includes(p);

          if (inCompany || inCEO || inYear) {
            matches += 1;

            if (
              (inCompany && inCEO) ||
              (inCompany && inYear) ||
              (inCEO && inYear)
            )
              multiFieldMatches += 1;

            if (
              (inCompany && company !== p && !company.startsWith(p)) ||
              (inCEO && ceo !== p && !ceo.startsWith(p))
            )
              partialMatches += 1;
          }
        });

        if (matches === 0) return null;

        let score = 1; // lower = better

        if (company === query) score -= 0.7;
        else if (company.startsWith(query)) score -= 0.4;
        else score += partialMatches * 0.05;

        if (ceo === query) score -= 0.6;
        else if (ceo.startsWith(query)) score -= 0.35;

        if (year.toString() === query) score -= 0.5;
        else if (year.toString().includes(query)) score -= 0.25;

        score -= multiFieldMatches * 0.15;
        score -= matches * 0.1;

        const companyDist = levenshtein(query, company);
        const ceoDist = levenshtein(query, ceo);
        score += Math.min(companyDist, ceoDist) * 0.05;

        return { ...item, score };
      })
      .filter(Boolean);

    return results
      .sort((a, b) => {
        const scoreDifference = a.score - b.score;
        if (scoreDifference !== 0) return scoreDifference;

        const aYear = Number.parseInt(a.year, 10) || 0;
        const bYear = Number.parseInt(b.year, 10) || 0;
        return bYear - aYear;
      })
      .slice(0, 20);
  }, [searchQuery, allCeoWorkerData]);

  const handleSearch = async (value) => {
    setSearchQuery(value);

    if (!value.trim()) {
      setFilteredData([]);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/ceo-worker-semantic-search`,
        { query: value, tab_type: "ceo-worker", device_type: deviceType }
      );

      const rawData = res.data?.data || [];
      const data = rawData.map((row, index) => ({
        id: `${(row["Company Name"] || "").trim()}-${(
          row["CEO Name"] || ""
        ).trim()}-${(row["Year"] || "").toString().trim()}-${index}`,
        company_name: (row["Company Name"] || "").trim(),
        year: (row["Year"] || "").toString().trim(),
        ceo_name: (row["CEO Name"] || "").trim(),
        ceo_total_compensation: (row["CEO Total Compensation"] || "").trim(),
        worker_salary: (row["Frontline Worker Salary"] || "").trim(),
        pay_ration: (row["Pay Ration"] || "N/A").trim(),
        pay_ratio: (row["Pay Ratio"] || "N/A").trim(),
      }));

      setAllData(data);

      // FIXED: Improved filtering logic with better search term matching
      const searchTerms = value.toLowerCase().trim().split(/\s+/);

      const filtered = data.filter((row) => {
        const companyName = (row.company_name || "").toLowerCase();
        const ceoName = (row.ceo_name || "").toLowerCase();
        const year = (row.year || "").toString().toLowerCase();

        // Check if any search term matches company name, CEO name, or year
        return (
          searchTerms.some(
            (term) =>
              companyName.includes(term) ||
              ceoName.includes(term) ||
              year.includes(term)
          ) ||
          // Also check if the full query matches (for cases like partial names)
          companyName.includes(value.toLowerCase()) ||
          ceoName.includes(value.toLowerCase()) ||
          year.includes(value.toLowerCase())
        );
      });

      const sorted = [...filtered]
        .filter((row) => row.year)
        .sort((a, b) => parseInt(b.year) - parseInt(a.year));

      const topFourYears = sorted.slice(0, 4);

      setError("");
      setFilteredData(topFourYears);
    } catch (err) {
      setFilteredData([]);
      console.error("CEO-Worker search failed:", err);
      setError(`CEO-Worker Not found for: ${value}.`);
      // setError(`Failed to load data: ${err.message}. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch(searchQuery);
    }
  };

  const handleSuggestionSelect = (event, value) => {
    if (value && typeof value === "object") {
      // Create a payload with CEO name, company name, and year
      const payload = {
        ceoName: value.ceoName,
        companyName: value.companyName,
        year: value.year,
        ceoCompensation: value.ceoCompensation,
        workerSalary: value.workerSalary,
      };

      // Instead of using the formatted label, use just the company name
      // This avoids the double slash issue in the API call
      const searchTerm = value.companyName; // or value.ceoName if you prefer

      setSearchQuery(value.label); // This shows the full formatted text in the input
      handleSearch(value.label); // This sends a clean search term to the API
    } else if (typeof value === "string") {
      // Clean the string to remove any extra formatting
      const cleanValue = value.replace(/\\/g, "").trim();
      const isNumeric = (value) => /^\d+$/.test(value);
      if (isNumeric(value)) {
        if (suggestions.length >= 1) {
          handleSearch(suggestions[0].label);
          setSearchQuery(suggestions[0].label);
        } else handleSearch(value);
      } else {
        setSearchQuery(cleanValue);
        handleSearch(cleanValue);
      }
    }
  };

  function valuetext(value) {
    return `${value}°C`;
  }

  const LoadingComponent = () => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
        Searching CEO-Worker data...
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, color: "text.disabled" }}>
        Analyzing compensation information
      </Typography>
    </Box>
  );

  const InitialLoadingComponent = () => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
        Loading CEO-Worker data
      </Typography>
      <Typography variant="body2" sx={{ mt: 1, color: "text.disabled" }}>
        This may take a moment
      </Typography>
    </Box>
  );

  if (initialDataLoading) {
    return <InitialLoadingComponent />;
  }

  return (
    <>
      <div className="meow">
        {
          filteredData.length > 0 ?
            <>
              <div className="pointer d-flex" onClick={() => {
                onSearchResultsFound(false)
                setError("");
                setSelectedOption(null);
                setSearchQuery("");
                setFilteredData([]);
                return;
                return;
              }}><img width="22" height="22" src="https://img.icons8.com/sf-ultralight-filled/25/00c062/chevron-left.png" alt="chevron-left" />
                <p className="mb-0 ms-1 back">Back to Home</p></div>
              <Typography variant="h4" textAlign="center" fontWeight="bold" className="py-gp mb-2"> Pay Gap</Typography>
            </> : ""

        }
        <Box m={0}
          // className="nomargin texter"
          className={filteredData.length > 0 ? "nomargin texter" : "nomargin "}
        >
          <label className="text-start">Search by company or CEO name</label>
          <Autocomplete
            freeSolo
            value={selectedOption}
            options={suggestions}
            // className="autoinput2 mt-1"
            className={filteredData.length > 0 ? "autoinput2 mt-2" : "autoinput mt-2"}
            getOptionLabel={(option) => {
              if (typeof option === "string") return option;
              return option.label || "";
            }}
            inputValue={searchQuery}
            onInputChange={(event, newInputValue) => {
              if (!newInputValue) {
                setError("");
                setSelectedOption(null);
                setSearchQuery("");
                setFilteredData([]);
                return;
              }
              setSelectedOption(null);
              setSearchQuery(newInputValue);
            }}
            onBlur={(event) => {
              const value = searchQuery.trim();
              if (value) {
                const isNumeric = (value) => /^\d+$/.test(value);
                if (isNumeric(value)) {
                  if (suggestions.length >= 1) {
                    handleSearch(suggestions[0].label);
                    setSearchQuery(suggestions[0].label);
                  } else handleSearch(searchQuery.trim());
                } else handleSearch(searchQuery.trim());
              }
            }}
            onChange={handleSuggestionSelect}
            // onKeyDown={handleKeyPress}
            noOptionsText={
              searchQuery.length < 1
                ? "Start typing to search for companies or CEOs..."
                : "No matching CEO-Worker data found"
            }
            disabled={loading}
            filterOptions={(options) => options}
            renderOption={(props, option) => (
              <Box component="li" {...props} key={option.id}>
                <Box
                  sx={{ display: "flex", alignItems: "center", width: "100%" }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="body2" fontWeight="bold">
                      <span style={{ color: "#1976d2" }}>
                        {option.companyName}
                      </span>
                      <span style={{ color: "#666", fontWeight: "normal" }}>
                        {" "}
                        - {option.ceoName}
                      </span>
                      <span style={{ color: "#999", fontWeight: "normal" }}>
                        {" "}
                        ({option.year})
                      </span>
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      CEO: {option.ceoCompensation} • Worker:{" "}
                      {option.workerSalary}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
            renderInput={(params) => (

              <TextField
                {...params}
                // label="Search by company or CEO name"
                variant="outlined"
                className="input-form"
                placeholder="Type to filter..."
                fullWidth
                disabled={loading || initialDataLoading}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <CircularProgress size={20} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Box>
      </div>

      {loading && <LoadingComponent />}

      {error && (
        <Typography color="error" align="center">
          {error}
        </Typography>
      )}

      {/* <>
      {!loading && searchQuery && filteredData.length === 0 && !error && (
        <Typography
          align="center"
          color="textSecondary"
          my={4}
          dangerouslySetInnerHTML={{
            __html: `No Match found for <strong>${searchQuery
              .split(" ")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(" ")}</strong>`,
          }}
          />
        )}
        </> */}


      {!!filteredData.length &&
        !error &&
        // (isDesktop ?
        //    (
        <div className="paygap_card">
          {filteredData.map((row, index) => {
            // console.log("pppppppp", row)
            return (
              <>
                <Card
                  elevation={3}
                  sx={{
                    p: 2,
                    borderRadius: 1,
                    mb: 2,
                    boxShadow: "none"
                  }}
                  className="pay-gap"
                >
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start", // optional if you want top alignment
                    }}
                  >
                    {/* Left Column */}
                    <Grid item xs={12} md={6} className="customWidthCeo">
                      <CardContent sx={{ p: 0, }} className="car">
                        <Typography
                          variant="h5"
                          align="left"
                          sx={{ fontWeight: "600", mb: 1, fontSize: "24px" }}
                        >
                          {row.company_name} ({row.year})
                          {<Tooltip
                            title="an estimate"
                            placement="right"
                            sx={{ cursor: "pointer" }}
                          >
                            *
                          </Tooltip>}
                        </Typography>

                        {/* Progress Bar */}
                        {/* <Box sx={{ mt: 1, mb: 1 }}>
                          <LinearProgress
                            variant="determinate"
                            value={row.worker_salary} // adjust dynamically
                            sx={{
                              height: 12,
                              borderRadius: 2,
                              backgroundColor: "#e0e0e0",
                              "& .MuiLinearProgress-bar": {
                                backgroundColor: "#1976d2",
                              },
                            }}
                          />
                        </Box> */}

                        {/* CEO vs Worker info */}
                        {/* {<Typography
                          align="left"
                          variant="h6"
                          sx={{ color: "#000" }}
                        >
                          {row.ceo_name} –{" "}
                          <strong>{row.ceo_total_compensation}</strong> vs
                          Worker <strong>{row.worker_salary}</strong>{" "}
                          {formatPayRatio(row["pay_ration"])}.
                        </Typography> } */}
                      </CardContent>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={12} md={6} className="customWidthCeoNumber w-full">
                      <CardContent className="chart-text"
                      // sx={{ p: 0, display: "flex" }}
                      >
                        <div className="chart-main">

                          <Pie data={data} options={options} />



                          <Typography variant="h6" mt="10px" align="left" fontSize="18px" fontWeight="400" className="chart_value">
                            {
                              deviceType === "desktop"
                                ? formatPayRatio(row["pay_ration"])
                                : formatPayRatio(row["pay_ratio"])
                            } Gap
                          </Typography>


                        </div>
                        <Typography variant="h6" mt="10px" align="left" fontSize="18px" fontWeight="400" className="copy_right">
                          {row.ceo_name} makes <strong>{row.year == 2025 ? row.ceo_total_compensation : row.ceo_total_compensation == "N/A" ? "$0.00" : row.ceo_total_compensation}</strong> the average worker making <strong>{row?.worker_salary}</strong>
                        </Typography>
                        <Typography variant="h6" mt="10px" align="left" fontSize="18px" fontWeight="400" className="copy_right">
                          (  {
                            deviceType === "desktop"
                              ? formatPayRatio(row["pay_ration"])
                              : formatPayRatio(row["pay_ratio"])
                          }  Gap)
                        </Typography>
                        <DynamicGraph rawValue={deviceType === "desktop" ? row["pay_ration"] ? Number((row["pay_ration"])?.replace("X", "")) : 0 : row["pay_ratio"] ? Number((row["pay_ratio"])?.replace("X", "")) : 0} />
                        {/* <div className="range_slider">
                      <Slider
                        aria-label="Custom marks"
                        value={  deviceType === "desktop" ? row["pay_ration"] ? Number((row["pay_ration"])?.replace("X","")) : 0 : row["pay_ratio"] ? Number((row["pay_ratio"])?.replace("X","")) : 0}                      // fixed value
                        onChange={() => {}}             // 👈 prevents movement
                        getAriaValueText={valuetext}
                        step={100}
                        min={0}
                        max={1000}
                        valueLabelDisplay="auto"
                        marks={marks}
                      />

                    </div> */}
                      </CardContent>
                    </Grid>
                  </Grid>

                  <Typography variant="h5" mt="10px" align="left" className="pro-heading-paygap">
                    Summary
                  </Typography>
                  <Typography variant="h6" mt="10px" align="left" fontSize="18px" fontWeight="400" className="copy_right">
                    The average {row.company_name} worker makes {row.worker_salary}  a year.  The CEO, {row.ceo_name} made {row.ceo_total_compensation}
                    {" "}   in {row.year}
                    . That’s{" "}
                    {
                      deviceType === "desktop"
                        ? formatPayRatio(row["pay_ration"])
                        : formatPayRatio(row["pay_ratio"])
                    }  times more than the average {row.company_name} worker.


                  </Typography>




                  {/* <Typography variant="h6" mt="10px" align="left">
                    CEO {row.ceo_name} made an estimate of{" "}
                    {row.ceo_total_compensation} vs. the average worker making{" "}
                    {row.worker_salary}. That’s{" "}
                    {formatPayRatio(row["pay_ration"])} times more.
                  </Typography> */}
                </Card>
              </>
            )
          })}
        </div>
        // ) 
        // : (
        //   <>


        // {
        /* <div className="paygap_card">
        {filteredData.map((row, index) => (
          <Card
            elevation={3}
            sx={{
              p: 2,
              borderRadius: 3,
              mb: 2,
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start", 
              }}
            >
            
              <Grid item xs={12} md={6} className="customWidthCeo">
                <CardContent sx={{ p: 0 }} className="nopadding">
                  <Typography
                    variant="h4"
                    align="left"
                    sx={{ fontWeight: "bold", mb: 2 }}
                  >
                    {row.company_name} ({row.year})
                    <Tooltip
                      title="an estimate"
                      placement="right"
                      open={open === index}
                      sx={{ cursor: "pointer" }}
                    >
                      <span onClick={() => setopen(index)}>*</span>
                    </Tooltip>
                  </Typography>
  
                 
                  <Box sx={{ mt: 1, mb: 1 }}>
                    <LinearProgress
                      variant="determinate"
                      value={row.worker_salary} // adjust dynamically
                      sx={{
                        height: 12,
                        borderRadius: 2,
                        backgroundColor: "#e0e0e0",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#1976d2",
                        },
                      }}
                    />
                  </Box>
                </CardContent>
              </Grid>
  
            
              <Grid item xs={12} md={6}>
                <CardContent
                  sx={{ p: 0, display: "flex", justifyContent: "center" }}
                  className="nopadding"
                >
                  <Box
                    className="RatioMobile"
                    sx={{
                      minWidth: 120,
                      minHeight: 120,
                      borderRadius: "50%",
                      backgroundColor: "#18A677",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                    }}
                  >
                    {formatPayRatio(row["pay_ratio"])}
                  </Box>
                </CardContent>
              </Grid>
            </Grid>
  
           
            <Typography align="left" variant="h6" sx={{ color: "#000" }}>
              {row.ceo_name} –{" "}
              <strong>{row.ceo_total_compensation}</strong> vs Worker{" "}
              <strong>{row.worker_salary}</strong> (
              {formatPayRatio(row["pay_ratio"])})
            </Typography>
  
            <Typography variant="h6" mt="10px" align="left">
              CEO {row.ceo_name} made {row.ceo_total_compensation} vs. the
              average worker making {row.worker_salary}. That’s{" "}
              {formatPayRatio(row["pay_ratio"]).replace(" ×", "")} times
              more.
            </Typography>
          </Card>
        ))}
      </div> */
        // }
        // </>
        // )
        // )
      }
    </>
  );
};
